import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Email } from '../../../../components/Email';
import { Link } from 'react-router-dom';

class LegalNotice extends React.Component {

  public render() {
    return (
      <div className="container">
        <Row>
          <Col sm={12}>
            <h2>Mentions légales</h2>

            <p>
              MS Amlin Insurance S.E. - Société Européenne de droit belge au capital de 1 321 489 euros, dont le siège
              social est situé 37 Boulevard Roi Albert II 1030 Bruxelles (Belgique) - Immatriculée à la BCE
              (Banque-Carrefour des Entreprises) à Bruxelles sous le numéro 0644 921 425 et soumise au contrôle de la
              BNB (Banque nationale de Belgique).
            </p>
            <p>
              Sa succursale en France est autorisée à exercer en France sous le régime de la liberté d’établissement ;
              elle est située 58 bis rue La Boétie 75008 Paris<br />
              RCS Paris 815 053 483<br />
              Coordonnées : T +33 (0)1 44 70 71 00 - F +33 (0)1 42 93 47 42  contact.france@msamlin.com<br />
              TVA intracommunautaire : FR78 815 053 483
            </p>
            <p>
              Ce site est hébergé par :<br />
              Socrates Systems,<br />
              6B Limes Court,<br />
              Conduit Lane,<br />
              Hoddesdon, Hertfordshire, EN11 8EP
            </p>
            <p>
              Directeur de la publication : Véronique Pérottino
            </p>

            <h3>Réclamations</h3>

            <p>
              En cas de difficulté ou de désaccord avec l’interlocuteur habituel de MS Amlin, ou si la réponse apportée
              ne satisfait pas le client, celui-ci pourra s’adresser au Service Client.
            </p>
            <ul>
              <li>Par email : <Email email={'serviceclient.france@msamlin.com'}/></li>
              <li>Par courrier : MS Amlin – Service Client - 58bis rue La Boétie – 75008 Paris</li>
              <li>Par téléphone : 01 44 70 71 00</li>
            </ul>
            <p>
              Si vous souhaitez plus d’informations sur notre procédure de traitement des réclamations, nous vous
              invitons à consulter notre site internet&nbsp;:&nbsp;
              <a href="https://www.msamlin.com/en/markets/France/Partenariat/R%C3%A9clamations.html" target="_blank">
                https://www.msamlin.com/en/markets/France/Partenariat/R%C3%A9clamations.html</a>
            </p>

            <h3>Conditions générales d’utilisation du Site</h3>
            <p>
              L’utilisation du présent site est soumise aux conditions générales d’utilisation accessibles ici<br />
              <Link to="/general-conditions">Conditions générales d’Utilisation du Site</Link>.
            </p>

            <h3>Politique de confidentialité</h3>
            <p>
              Nous vous informons que vos données ont été ou seront collectées ou reçues par MS Amlin limited. Nous
              gérerons les données à caractère personnel conformément aux principes et aux lois en matière de protection
              des données. Nous avons besoin de données à caractère personnel pour fournir des services d’assurance de
              qualité et nous ne collecterons que les données nécessaires. Il peut s’agir d’informations personnelles
              telles que le nom, l’adresse, les coordonnées, les numéros d’identification, les informations financières
              et le profil de risque.
            </p>
            <p>
              L’avis complet est disponible sur :&nbsp;
              <a href="https://www.msamlin.com/en/site-services/data-privacy-notice/
avis-de-la-protection-des-donnees-des-clients.html" target="_blank">
                https://www.msamlin.com/en/site-services/data-privacy-notice/avis-de-la-protection-des-donnees
                -des-clients.html
              </a>
            </p>
            <p>
              Une version papier est également disponible en contactant le Data Protection Officer (Responsable de la
              Protection des Données) par email (dataprotectionofficer@msamlin.com) ou par courrier à l’adresse
              ci-dessous :<br />
              Délégué à la protection des données (The Data Protection Officer)<br />
              MS Amlin limited<br />
              The Leadenhall Building<br />
              122 Leadenhall Street<br />
              Londres - EC3V 4AG
            </p>

            <h3>Cookies</h3>
            <p>
              Notre politique de cookies s'applique aux URL msamlin.com, amlin.co.uk et amlin.com (les "Sites MS Amlin",
              chacun un "Site MS Amlin") détenues ou gérées par ou pour le compte de MS Amlin limited et des sociétés
              détenues indirectement par MS Amlin limited ("MS Amlin", "nous", "notre").<br />
              Veuillez lire attentivement les termes de cette politique sur les cookies car elle explique comment MS
              Amlin utilise les informations personnelles que nous recueillons ou recevons à votre sujet lorsque vous
              accédez ou utilisez les Sites MS Amlin. En accédant ou en utilisant les sites MS Amlin, vous acceptez que
              nous collections vos données personnelles comme indiqué dans cette politique relative aux cookies.
            </p>

            <h3>UTILISATION DE COOKIES</h3>
            <p>
              Les sites MS Amlin peuvent utiliser des cookies (fichiers texte placés sur votre ordinateur) pour vous
              distinguer des autres utilisateurs de notre site Web. Cela nous aide à vous offrir une bonne expérience
              lorsque vous naviguez sur notre site Web et nous permet également d'améliorer les sites MS Amlin.
            </p>
            <p>
              Nous vous invitons à consulter notice complète relative aux cookies en cliquant sur le lien
              ci-dessous :&nbsp;
              <a href="https://www.msamlin.com/en/site-services/cookie-policy.html" target="_blank">
                https://www.msamlin.com/en/site-services/cookie-policy.html
              </a>
            </p>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(LegalNotice);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/LegalNotice/index.tsx